import styled from "styled-components";

export default styled.div`
  background: #187a6c;
  background: #002a24;
  color: #00ffdb;
  width: 350px;
  font-size: 32px;
  padding: 15px;
  text-align: left;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5) inset;
  font-family: monospace;
`;
